<template>
  <div
    :class="[
      'ProgressBar relative flex justify-center pb-3',
      hasKiosk ? 'pb-6' : '',
    ]"
  >
    <ol class="flex justify-center w-fit relative mt-6" ref="container">
      <li
        ref="child"
        v-for="({ text }, index) in steps.filter(({ text }) => text)"
        :key="index"
        :class="[
          'ProgressBar__step',
          'font-semibold tracking-wide z-10 cursor-default',
        ]"
        :style="stepsBorder"
      >
        <div
          :class="[
            menu.layout == 'frydate' ? 'text-4xl ' : 'py-2 ',
            'relative z-10 rounded-full px-4',
            index < current && menu.layout != 'frydate' && 'opacity-75',
          ]"
          :style="makeStyles(current === index ? stepsActiveBackground : stepsBackground,progressBarRadius)"
        >
          <span
            :style="current === index ? stepsActiveNumber : stepsNumber"
            :class="index < current && menu.layout != 'frydate' && 'opacity-60'"
            >{{ index + 1 }}</span
          >
          <span
            v-if="current === index && menu.layout != 'frydate'"
            :style="current === index ? stepsActiveText : stepsText"
            :class="['ml-3 whitespace-no-wrap']"
            >{{ lang[text][language] }}</span
          >
        </div>
        <div
          class="absolute top-0 right-0 left-0 bottom-0 bg-white rounded-full"
        />
      </li>
      <div class="ProgressBar__backLine" :style="stepsLine" />
    </ol>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lang from "../lang";

/**
 * Should recieve an array of steps, if step disabled return object
 * Should emit event on step click
 */
export default {
  data() {
    return {
      current: 0,
      lang,
    };
  },
  props: {
    steps: Array,
    setCurrent: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(["menu","language", "hasKiosk"]),
    ...mapGetters("Theme", [
      "stepsBackground",
      "progressBarRadius",
      "stepsText",
      "stepsLine",
      "stepsActiveBackground",
      "stepsActiveText",
      "stepsNumber",
      "stepsActiveNumber",
      "stepsBorder",
      "stepsBackdropBackground",
    ]),
  },
  watch: {
    setCurrent(value) {
      this.current = value;
      // const currentChild = this.$refs.child[value];
    },
  },
};
</script>

<style>
.ProgressBar__backLine {
  top: 50%;
  height: 2px;
  background-color: currentColor;
  @apply absolute left-0 right-0 bottom-0;
}

.ProgressBar__step {
  position: relative;
  @apply mr-6;
}

/* .ProgressBar__step::after {
        content: ' ';
        background: white;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        z-index: -2;
    } */

.ProgressBar__step:nth-last-child(2) {
  @apply mr-0;
}
</style>
